/**
 * BasicForm 协议：子组件 mixin 后按需覆盖 validate / isComplete / captureSnapshot。
 */
export default {
  data() {
    return {
      _completionEmitTimer: null,
    }
  },
  mounted() {
    this.$watch(
      () => (this.captureSnapshot ? this.captureSnapshot() : null),
      () => {
        this.scheduleCompletionEmit()
      },
      { deep: true }
    )
  },
  beforeDestroy() {
    if (this._completionEmitTimer) {
      clearTimeout(this._completionEmitTimer)
      this._completionEmitTimer = null
    }
  },
  methods: {
    buildExtaPayload() {
      return {}
    },
    loadFromExta() {},
    validate() {
      return Promise.resolve()
    },
    isComplete() {
      return true
    },
    reset() {},
    captureSnapshot() {
      return {}
    },
    scheduleCompletionEmit() {
      if (this._completionEmitTimer) {
        clearTimeout(this._completionEmitTimer)
      }
      this._completionEmitTimer = setTimeout(() => {
        this.$emit('completion-changed')
      }, 0)
    },
  },
}
